module.exports = __webpack_public_path__ + "pin-tuan/static/media/logo.8ea96b33.png";